/**
 * 就職進捗評価フォームの表示を、サーバーが返す回次に合わせる。
 */
const initCareerConsultationEvaluation = () => {
    const root = document.getElementById('job-hunting-evaluation');
    if (!root || !root.dataset.evaluationRoundUrl) {
        return;
    }

    const statusSelect = document.getElementById('job_hunting_status');
    const phaseSelect = document.getElementById('job_hunting_phase');
    const interventionCheckbox = document.getElementById('is_intervention_requested');
    const interventionDetail = document.getElementById('intervention_detail');
    const requiredMark = document.getElementById('intervention-detail-required-mark');
    // 「4. 運営への介入依頼」の囲み。非表示の間は理由・要望内容に required を付けない
    // @todo 運営が介入依頼を使い始めたら CareerConsultation::IS_INTERVENTION_REQUEST_DISPLAYED を true にする
    const interventionWrap = document.getElementById('intervention-request-wrap');
    const prescribed = document.getElementById('is_prescribed');
    const startedAt = document.querySelector('input[name="started_at"]');
    // 課題点「その他」のフリーコメント。チェック時だけ表示し、必須にする
    const issueOtherWrap = document.getElementById('job-hunting-issue-other-wrap');
    const issueOtherDetail = document.getElementById('job_hunting_issue_other_detail');
    const issueOtherCheckbox = document.getElementById(`job_hunting_issue_${root.dataset.issueOtherValue}`);
    const fields = root.querySelectorAll('#job_hunting_status, #job_hunting_phase, .job-hunting-issue, #job_hunting_issue_other_detail, #is_intervention_requested, #intervention_detail');

    let selectedStatus = statusSelect ? statusSelect.value : '';
    let timer = null;
    let requestId = 0;

    const syncInterventionDetail = () => {
        const requested = interventionCheckbox ? interventionCheckbox.checked : false;
        const visible = !root.classList.contains('hidden')
            && !(interventionWrap && interventionWrap.classList.contains('hidden'));
        if (requiredMark) {
            requiredMark.classList.toggle('hidden', !requested);
        }
        if (interventionDetail) {
            interventionDetail.required = requested && visible;
        }
    };

    const syncIssueOtherDetail = () => {
        if (!issueOtherWrap || !issueOtherDetail) {
            return;
        }
        const checked = issueOtherCheckbox ? issueOtherCheckbox.checked : false;
        const visible = !root.classList.contains('hidden');
        issueOtherWrap.classList.toggle('hidden', !checked);
        issueOtherDetail.required = checked && visible;
    };

    const fillStatusOptions = (options) => {
        if (!statusSelect) {
            return;
        }
        const current = selectedStatus;
        statusSelect.replaceChildren(new Option('', ''));
        Object.keys(options || {}).forEach((value) => {
            statusSelect.append(new Option(options[value], value));
        });
        if (current && options && Object.prototype.hasOwnProperty.call(options, current)) {
            statusSelect.value = current;
        }
    };

    const applyRound = (round, statusOptions) => {
        const visible = round === 2 || round === 3;
        root.classList.toggle('hidden', !visible);
        fields.forEach((field) => {
            field.disabled = !visible;
        });
        if (visible) {
            fillStatusOptions(statusOptions);
            if (statusSelect) {
                statusSelect.required = true;
            }
            if (phaseSelect) {
                phaseSelect.required = true;
            }
        } else {
            if (statusSelect) {
                statusSelect.required = false;
            }
            if (phaseSelect) {
                phaseSelect.required = false;
            }
            if (interventionDetail) {
                interventionDetail.required = false;
            }
        }
        syncInterventionDetail();
        syncIssueOtherDetail();
    };

    const fetchRound = () => {
        const current = ++requestId;
        const params = new URLSearchParams();
        params.set('is_prescribed', prescribed && prescribed.checked ? '1' : '0');
        params.set('started_at', startedAt ? startedAt.value : '');
        const schedule = document.querySelector('input[name="schedule_id"]');
        if (schedule && schedule.value !== '') {
            params.set('schedule_id', schedule.value);
        }
        const term = document.querySelector('input[name="term_id"]');
        if (term && term.value !== '') {
            params.set('term_id', term.value);
        }
        if (root.dataset.consultationId) {
            params.set('consultation_id', root.dataset.consultationId);
        }

        fetch(`${root.dataset.evaluationRoundUrl}?${params.toString()}`, {
            headers: { Accept: 'application/json' },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('evaluation round request failed');
                }
                return response.json();
            })
            .then((data) => {
                if (current !== requestId) {
                    return;
                }
                const round = data.round === null || data.round === undefined ? null : Number(data.round);
                applyRound(round, data.status_options || {});
            })
            .catch(() => {
                // 通信に失敗したときは表示を変えず、保存時にサーバーが回次を検証する。
            });
    };

    const queueRoundRequest = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(fetchRound, 300);
    };

    prescribed?.addEventListener('change', queueRoundRequest);
    startedAt?.addEventListener('change', queueRoundRequest);
    startedAt?.addEventListener('input', queueRoundRequest);
    interventionCheckbox?.addEventListener('change', syncInterventionDetail);
    issueOtherCheckbox?.addEventListener('change', syncIssueOtherDetail);
    statusSelect?.addEventListener('change', (event) => {
        selectedStatus = event.target.value;
    });

    fetchRound();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCareerConsultationEvaluation);
} else {
    initCareerConsultationEvaluation();
}
